import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ClassicLayoutComponent } from 'app/layout/layouts/vertical/classic/classic.component';
import { TranslocoModule } from "@jsverse/transloco";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    declarations: [
        ClassicLayoutComponent,
        
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        LanguagesModule,
        UserModule,
        SharedModule,
        TranslocoModule,
        MatTooltipModule,
        FuseFullscreenComponent,
        FuseHorizontalNavigationComponent,
        FuseVerticalNavigationComponent
    ],
    exports: [
        ClassicLayoutComponent,
    ]
})
export class ClassicLayoutModule
{
}
